export default __webpack_public_path__ + "static/media/audio-off.cdf94f65.svg";